import { useEffect, useRef, useState } from 'react';
import { ArrowDownToLine, ArrowRight } from 'lucide-react';
import { PageGrid } from './PageGrid';
import { SiteFadeInMount } from './SiteFadeIn';
import { DOWNLOAD_MAC_URL } from '../constants/download';

const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:5173';

export function CtaSection() {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0 },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={sentinelRef} className="h-px w-full" aria-hidden="true" />
      {isVisible && (
        <PageGrid as="section" className="w-full py-30">
          <div className="col-span-full lg:col-start-3 lg:col-span-8">
            <SiteFadeInMount>
              <div className="flex flex-col items-center gap-10 text-center">
                <h2 className="text-display lg:text-display-md text-text-primary">
                  Build with Arvid today.
                </h2>

                <div className="flex items-center gap-2">
                  <a href={DOWNLOAD_MAC_URL} className="site-btn-primary site-btn-md">
                    Download for macOS
                    <ArrowDownToLine size={14} />
                  </a>
                  <a href={`${APP_URL}/login`} className="site-btn-outline site-btn-md">
                    Launch Arvid
                    <ArrowRight size={14} />
                  </a>
                </div>
              </div>
            </SiteFadeInMount>
          </div>
        </PageGrid>
      )}
    </>
  );
}
